import { createAction, props } from '@ngrx/store';
import { FidPickerItem } from '../models/fid-picker.interface';

// Load FID Picker (trigger action - no data)
export const loadFidPicker = createAction(
  '[FID Picker] Load FID Picker'
);

// Load FID Picker Success (effect dispatches this)
export const loadFidPickerSuccess = createAction(
  '[FID Picker] Load FID Picker Success',
  props<{ items: FidPickerItem[] }>()
);

// Load FID Picker Failure (effect dispatches this)
export const loadFidPickerFailure = createAction(
  '[FID Picker] Load FID Picker Failure',
  props<{ error: string }>()
); 